import { render } from "./RedefinePassword.vue?vue&type=template&id=012e827c&scoped=true"
import script from "./RedefinePassword.vue?vue&type=script&lang=js"
export * from "./RedefinePassword.vue?vue&type=script&lang=js"

import "./RedefinePassword.vue?vue&type=style&index=0&id=012e827c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012e827c"]])

export default __exports__